import Model, { belongsTo, attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type School from 'teacher-ui-client/models/school'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type Teacher from 'teacher-ui-client/models/teacher'
import type StringTransform from 'teacher-ui-client/transforms/string'

export default class SubscriptionCoordinator extends Model {
  @belongsTo<School>('school', { async: false, inverse: 'subscriptionCoordinators' }) declare school?: School

  @belongsTo<Teacher>('teacher', { async: false, inverse: 'subscriptionCoordinators' }) declare teacher?: Teacher

  @attr<StringTransform>('string') declare product: SubscriptionType

  isForSubscriptionType(subscriptionType: SubscriptionType) {
    return this.product === subscriptionType
  }

  [Type] = 'subscription-coordinator' as const
}
